import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { DEFAULT_ASPECT_RATIO } from '../constants';
export const MediaWrapper = styled(Box).attrs(({ bg }) => ({
    bg: bg !== null && bg !== void 0 ? bg : 'smokeDark',
    position: 'relative',
    width: '100%',
})) `
  aspect-ratio: ${({ $aspectRatio = DEFAULT_ASPECT_RATIO }) => $aspectRatio};
`;
//# sourceMappingURL=MediaWrapper.js.map